const DEFAULT_LIFESPAN = 90;

const FIXED_ACTIVITIES = [
  { name: 'Birthdays', icon: '🎂', perYear: 1 },
  { name: 'Holidays with family', icon: '🎄', perYear: 1 },
  { name: 'Full moons seen', icon: '🌕', perYear: 12 },
  { name: 'Summers', icon: '☀️', perYear: 1 },
  { name: 'Winters', icon: '❄️', perYear: 1 },
];

const DEFAULT_CUSTOM_ACTIVITIES = [
  { icon: '📚', name: 'Books', perYear: 5 },
  { icon: '🍕', name: 'Pizzas', perYear: 12 },
  { icon: '🏊', name: 'Ocean swims', perYear: 1 },
];

let customActivities = [];

function getCustomActivities() {
  return customActivities;
}

function setCustomActivities(list) {
  customActivities = list;
  renderCustomActivityInputs();
}

function renderCustomActivityInputs() {
  const container = document.getElementById('liw-custom-activities');
  if (!container) return;
  container.innerHTML = '';

  customActivities.forEach((a, i) => {
    const row = document.createElement('div');
    row.className = 'liw-custom-row';
    row.innerHTML = `
      <input type="text" class="liw-input liw-input--emoji" value="${a.icon}" data-idx="${i}" data-field="icon" maxlength="2" title="Emoji">
      <input type="text" class="liw-input liw-input--name" value="${escapeHtml(a.name)}" data-idx="${i}" data-field="name" placeholder="Name">
      <input type="number" class="liw-input liw-input--rate" value="${a.perYear}" data-idx="${i}" data-field="perYear" min="0" max="1000" title="Times per year">
      <span class="liw-rate-label">/yr</span>
      <button class="liw-remove-btn" data-idx="${i}" title="Remove">✕</button>
    `;
    container.appendChild(row);
  });

  // Bind events
  container.querySelectorAll('.liw-input').forEach(input => {
    input.addEventListener('change', e => {
      const idx = parseInt(e.target.dataset.idx, 10);
      const field = e.target.dataset.field;
      if (field === 'perYear') {
        customActivities[idx][field] = Math.max(0, parseFloat(e.target.value) || 0);
      } else {
        customActivities[idx][field] = e.target.value;
      }
    });
  });

  container.querySelectorAll('.liw-remove-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      const idx = parseInt(e.target.dataset.idx, 10);
      customActivities.splice(idx, 1);
      renderCustomActivityInputs();
    });
  });
}

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

function buildGrid(containerId, total, lived) {
  const container = document.getElementById(containerId);
  if (!container) return;
  container.innerHTML = '';
  const fragment = document.createDocumentFragment();
  for (let i = 0; i < total; i++) {
    const dot = document.createElement('div');
    dot.className = 'liw-dot';
    if (i < lived) dot.classList.add('liw-dot--lived');
    else if (i === lived) dot.classList.add('liw-dot--current');
    fragment.appendChild(dot);
  }
  container.appendChild(fragment);
}

function renderActivityGrid(container, activity) {
  const remaining = Math.max(0, Math.round(activity.perYear * activity.yearsLeft));
  const total = activity.totalPast + remaining;
  if (total === 0) return;

  const section = document.createElement('div');
  section.className = 'liw-activity';

  const rateLabel = activity.perYear === 1 ? '1/yr'
    : activity.perYear === 12 ? '1/mo'
    : `${activity.perYear}/yr`;

  const hasEmoji = activity.icon && activity.icon.trim() !== '';
  const iconLabel = hasEmoji ? `${activity.icon} ` : '';

  section.innerHTML = `
    <p class="liw-activity-label">
      ${iconLabel}<strong>${escapeHtml(activity.name)}</strong> (${rateLabel})
      — <span class="liw-highlight">${Math.round(activity.totalPast)}</span> done,
      <span class="liw-muted">${remaining} left</span>
    </p>
  `;

  const grid = document.createElement('div');
  grid.className = 'liw-grid liw-grid--activity';
  const scale = total > 400 ? total / 400 : 1;
  const showTotal = Math.round(total / scale);
  const showLived = Math.round(Math.round(activity.totalPast) / scale);

  for (let i = 0; i < showTotal; i++) {
    if (hasEmoji) {
      const span = document.createElement('span');
      span.className = 'liw-emoji' + (i < showLived ? '' : ' liw-emoji--remaining');
      span.textContent = activity.icon;
      grid.appendChild(span);
    } else {
      const dot = document.createElement('div');
      dot.className = 'liw-dot' + (i < showLived ? ' liw-dot--lived' : '');
      grid.appendChild(dot);
    }
  }

  section.appendChild(grid);

  if (scale > 1) {
    const note = document.createElement('p');
    note.className = 'liw-scale-note';
    note.textContent = hasEmoji
      ? `(each ${activity.icon} represents ${Math.round(scale)})`
      : `(each dot represents ${Math.round(scale)})`;
    section.appendChild(note);
  }

  container.appendChild(section);
}

function buildActivities(yearsLived, yearsLeft) {
  const container = document.getElementById('liw-activities');
  if (!container) return;
  container.innerHTML = '';

  // Fixed activities
  FIXED_ACTIVITIES.forEach(a => {
    renderActivityGrid(container, {
      ...a,
      totalPast: yearsLived * a.perYear,
      yearsLeft,
    });
  });

  // Custom activities
  const customs = getCustomActivities();
  if (customs.length > 0) {
    const divider = document.createElement('hr');
    divider.className = 'liw-activity-divider';
    container.appendChild(divider);

    customs.forEach(a => {
      if (!a.name || a.perYear <= 0) return;
      renderActivityGrid(container, {
        icon: a.icon || '',
        name: a.name,
        perYear: a.perYear,
        totalPast: yearsLived * a.perYear,
        yearsLeft,
      });
    });
  }
}

function buildTailEnd(yearsLived, yearsLeft) {
  const leftHome = 18;

  const relationships = [
    {
      name: 'Parents',
      detail: 'Assuming you left home at 18, see them ~10 days/year after',
      calc: () => {
        const childhoodYrsLived = Math.min(yearsLived, leftHome);
        const adultYrsLived = Math.max(0, yearsLived - leftHome);
        const pastDays = childhoodYrsLived * 365 * 0.9 + adultYrsLived * 10;

        const childhoodYrsLeft = Math.max(0, leftHome - yearsLived);
        const adultYrsLeft = Math.max(0, Math.min(yearsLeft - childhoodYrsLeft, 30));
        const futureDays = childhoodYrsLeft * 365 * 0.9 + adultYrsLeft * 10;
        return { past: pastDays, future: futureDays };
      }
    },
    {
      name: 'Siblings',
      detail: 'Lived together ~15 years, then ~15 days/year',
      calc: () => {
        const togetherYrsLived = Math.min(yearsLived, 15);
        const apartYrsLived = Math.max(0, yearsLived - 15);
        const past = togetherYrsLived * 365 * 0.8 + apartYrsLived * 15;

        const togetherYrsLeft = Math.max(0, 15 - yearsLived);
        const apartYrsLeft = Math.max(0, Math.min(yearsLeft - togetherYrsLeft, 60));
        const future = togetherYrsLeft * 365 * 0.8 + apartYrsLeft * 15;
        return { past, future };
      }
    },
    {
      name: 'High school friends',
      detail: '~5 days/week for ages 14–18, then ~1 day/year',
      calc: () => {
        const hsStart = 14;
        const hsEnd = 18;
        const highRate = 200;
        const lowRate = 1;

        const hsYrsLived = Math.max(0, Math.min(yearsLived, hsEnd) - hsStart);
        const afterYrsLived = Math.max(0, yearsLived - hsEnd);
        const past = hsYrsLived * highRate + afterYrsLived * lowRate;

        const hsYrsLeft = Math.max(0, hsEnd - Math.max(yearsLived, hsStart));
        const afterYrsLeft = yearsLived >= hsEnd ? yearsLeft : Math.max(0, yearsLeft - hsYrsLeft);
        const future = (yearsLived >= hsStart ? hsYrsLeft * highRate : 0) + afterYrsLeft * lowRate;

        if (yearsLived < hsStart) return { past: 0, future };
        return { past, future };
      }
    },
    {
      name: 'College friends',
      detail: '~6 days/week for ages 18–22, then ~5 days/year',
      calc: () => {
        const colStart = 18;
        const colEnd = 22;
        const highRate = 250;
        const lowRate = 5;

        const colYrsLived = Math.max(0, Math.min(yearsLived, colEnd) - colStart);
        const afterYrsLived = Math.max(0, yearsLived - colEnd);
        const past = colYrsLived * highRate + afterYrsLived * lowRate;

        const colYrsLeft = Math.max(0, colEnd - Math.max(yearsLived, colStart));
        const afterYrsLeft = yearsLived >= colEnd ? yearsLeft : Math.max(0, yearsLeft - colYrsLeft);
        const future = (yearsLived >= colStart ? colYrsLeft * highRate : 0) + afterYrsLeft * lowRate;

        if (yearsLived < colStart) return { past: 0, future };
        return { past, future };
      }
    },
  ];

  const container = document.getElementById('liw-tail-end-bars');
  if (!container) return;
  container.innerHTML = '';

  let parentPct = null;

  relationships.forEach(r => {
    const { past, future } = r.calc();
    const total = past + future;
    if (total === 0) return;
    const pct = Math.min(100, (past / total * 100)).toFixed(0);

    if (r.name === 'Parents') parentPct = pct;

    container.innerHTML += `
      <div class="liw-bar-row">
        <div class="liw-bar-label">${r.name}</div>
        <div class="liw-bar-track">
          <div class="liw-bar-fill" style="width: ${pct}%"></div>
        </div>
        <div class="liw-bar-pct">${pct}%</div>
      </div>
      <p class="liw-bar-detail">${r.detail}</p>
    `;
  });

  const desc = document.getElementById('liw-tail-end-desc');
  if (desc && parentPct !== null) {
    desc.textContent = yearsLived >= 18
      ? `If you left home at 18, you've already used up ~${parentPct}% of your in-person time with your parents. Here's what the "tail end" looks like based on your age.`
      : `You've spent ~${parentPct}% of your in-person parent time so far. Here's what the "tail end" looks like based on your age.`;
  }
}

function generate() {
  const input = document.getElementById('liw-birthdate').value;
  if (!input) { alert('Please enter your birth date.'); return; }

  const birthDate = new Date(input);
  const now = new Date();
  if (birthDate >= now) { alert('Birth date must be in the past.'); return; }

  const lifespanInput = parseInt(document.getElementById('liw-lifespan').value, 10);
  const lifespan = (lifespanInput > 0 && lifespanInput <= 150) ? lifespanInput : DEFAULT_LIFESPAN;

  const ageMs = now - birthDate;
  const ageYears = ageMs / (365.25 * 24 * 60 * 60 * 1000);
  const ageMonths = ageYears * 12;
  const ageWeeks = ageYears * 52.18;

  const yearsLived = Math.floor(ageYears);
  const monthsLived = Math.floor(ageMonths);
  const weeksLived = Math.floor(ageWeeks);
  const yearsLeft = Math.max(0, lifespan - yearsLived);
  const pctLived = ((ageYears / lifespan) * 100).toFixed(1);

  document.getElementById('liw-intro').classList.add('liw-hidden');
  document.getElementById('liw-dashboard').classList.add('liw-visible');

  document.getElementById('liw-stats').innerHTML = `
    <div class="liw-stat"><span class="liw-stat-number">${yearsLived}</span><span class="liw-stat-label">Years Lived</span></div>
    <div class="liw-stat"><span class="liw-stat-number">${yearsLeft}</span><span class="liw-stat-label">Years Left</span></div>
    <div class="liw-stat"><span class="liw-stat-number">${pctLived}%</span><span class="liw-stat-label">Life Elapsed</span></div>
    <div class="liw-stat"><span class="liw-stat-number">${weeksLived.toLocaleString()}</span><span class="liw-stat-label">Weeks Lived</span></div>
    <div class="liw-stat"><span class="liw-stat-number">${(lifespan * 52 - weeksLived).toLocaleString()}</span><span class="liw-stat-label">Weeks Left</span></div>
  `;

  buildGrid('liw-years-grid', lifespan, yearsLived);
  document.getElementById('liw-years-progress').innerHTML =
    `<span class="liw-highlight">${yearsLived}</span> of ${lifespan} years lived`;

  const totalMonths = lifespan * 12;
  buildGrid('liw-months-grid', totalMonths, monthsLived);
  document.getElementById('liw-months-progress').innerHTML =
    `<span class="liw-highlight">${monthsLived}</span> of ${totalMonths.toLocaleString()} months lived`;

  const totalWeeks = lifespan * 52;
  buildGrid('liw-weeks-grid', totalWeeks, weeksLived);
  document.getElementById('liw-weeks-progress').innerHTML =
    `<span class="liw-highlight">${weeksLived.toLocaleString()}</span> of ${totalWeeks.toLocaleString()} weeks lived`;

  buildActivities(yearsLived, yearsLeft);
  buildTailEnd(yearsLived, yearsLeft);

  document.getElementById('liw-dashboard').scrollIntoView({ behavior: 'smooth' });
}

function encodeCustomActivities() {
  return customActivities
    .filter(a => a.name)
    .map(a => `${a.icon}|${a.name}|${a.perYear}`)
    .join(';;');
}

function decodeCustomActivities(str) {
  if (!str) return null;
  return str.split(';;').map(entry => {
    const [icon, name, perYear] = entry.split('|');
    return { icon: icon || '', name: name || '', perYear: parseFloat(perYear) || 0 };
  }).filter(a => a.name);
}

function buildShareUrl() {
  const url = new URL(window.location.pathname, window.location.origin);
  const birthdate = document.getElementById('liw-birthdate').value;
  const lifespan = document.getElementById('liw-lifespan').value;

  if (birthdate) url.searchParams.set('born', birthdate);
  if (lifespan && lifespan !== '90') url.searchParams.set('lifespan', lifespan);

  const encoded = encodeCustomActivities();
  if (encoded) url.searchParams.set('activities', encoded);

  return url.toString();
}

function share() {
  const url = buildShareUrl();
  history.replaceState(null, '', url);

  if (navigator.clipboard) {
    navigator.clipboard.writeText(url).then(() => {
      const btn = document.getElementById('liw-share');
      const original = btn.textContent;
      btn.textContent = '✓ Copied!';
      setTimeout(() => { btn.textContent = original; }, 2000);
    });
  }
}

function loadFromParams() {
  const params = new URLSearchParams(window.location.search);

  const born = params.get('born');
  if (born) document.getElementById('liw-birthdate').value = born;

  const lifespan = params.get('lifespan');
  if (lifespan) document.getElementById('liw-lifespan').value = lifespan;

  const activitiesParam = params.get('activities');
  const decoded = decodeCustomActivities(activitiesParam);
  if (decoded) {
    setCustomActivities(decoded);
  }

  return !!born;
}

function goBack() {
  document.getElementById('liw-intro').classList.remove('liw-hidden');
  document.getElementById('liw-dashboard').classList.remove('liw-visible');
  history.replaceState(null, '', window.location.pathname);
}

document.addEventListener('DOMContentLoaded', () => {
  const genBtn = document.getElementById('liw-generate');
  const backBtn = document.getElementById('liw-back');
  const shareBtn = document.getElementById('liw-share');
  const addBtn = document.getElementById('liw-add-activity');
  const dateInput = document.getElementById('liw-birthdate');

  if (genBtn) genBtn.addEventListener('click', generate);
  if (backBtn) backBtn.addEventListener('click', goBack);
  if (shareBtn) shareBtn.addEventListener('click', share);
  if (dateInput) dateInput.addEventListener('keypress', e => { if (e.key === 'Enter') generate(); });

  if (addBtn) {
    addBtn.addEventListener('click', () => {
      customActivities.push({ icon: '', name: '', perYear: 1 });
      renderCustomActivityInputs();
    });
  }

  // Load from URL params or use defaults
  const hadParams = loadFromParams();
  if (!hadParams) {
    setCustomActivities(DEFAULT_CUSTOM_ACTIVITIES.map(a => ({ ...a })));
  }

  if (hadParams) generate();
});
